import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import { usePreviewModeContext } from 'src/common/providers/PreviewModeProvider';
import getClassNames from 'src/common/utils/getClassNames';
import IconDS22 from 'src/common/components/IconDS22';

import styles from './BookingCounter.module.scss';

export type BookingCounterProps = {
  totalBookings: number;
  classNameModifier?: string;
  disabled?: boolean;
};

const BookingCounter: FC<BookingCounterProps> = (
  { totalBookings, classNameModifier, disabled },
) => {
  const [t] = useTranslation('listing-page');
  const { previewMode } = usePreviewModeContext();

  if (!previewMode && !disabled && !totalBookings) {
    return null;
  }

  const totalCount = classNameModifier === 'boatOwnerInfo'
    ? t('bookingCountTotal', { count: totalBookings })
    : t('bookingCount', { count: totalBookings });

  return (
    <div className={getClassNames(styles, 'root', classNameModifier)}>
      <IconDS22
        id="check-circle"
        size="m"
        className={styles.icon}
      />
      <span
        className={getClassNames(
          styles,
          'label',
          classNames(classNameModifier, { disabled: previewMode }),
        )}
      >
        {totalCount}
      </span>
    </div>
  );
};

export default BookingCounter;
